module.exports = __webpack_public_path__ + "img/fleetTB.a81985b0.jpg";